'use client';

export default function TaC() {
    return (
        <div className="p-6 space-y-5 text-gray-200 max-h-[70vh] overflow-y-auto">

            <h3 className="text-2xl font-bold text-white mb-4">Terms and Conditions</h3>

            <p className="text-sm leading-relaxed">
                By creating an account, you agree to the Terms and Conditions, Privacy Policy, and Cookies Policy on our website as well as the Terms and Conditions of the Store.
                You must be 18 years of age or older to use the Store. Please ensure all information provided is accurate and complete — failure to do so may result in suspension or deletion of your user account.
            </p>

            <p className="text-sm leading-relaxed">
                <strong>Sokoloco.gg</strong> facilitates and promotes prizes and rewards sponsored by affiliated partners on our website&apos;s &quot;Store&quot; page, intended solely as a gesture of gratitude to our loyal users.
            </p>

            <p className="text-sm leading-relaxed">
                To participate in the Store, users must have previously collected <strong>Kick Points</strong> through engagement on Sokoloco.gg, such as watching live streams, participating in events, or special giveaways.
                Each sponsored item varies in cost depending on the prize type. Users may only use their own account to trade or redeem items. The use of multiple accounts or browser manipulation (e.g., multiple tabs or devices) is strictly prohibited and will be considered system abuse, resulting in suspension or termination of the account.
            </p>

            <p className="text-sm leading-relaxed">
                Sponsored items in the Store may be of pecuniary or non-pecuniary nature. Users can browse available items and redeem them using Kick Points.
                After redemption, a &quot;pending&quot; status will appear until reviewed. Once approved, delivery or access to the prize may take up to 14 business days.
                Transfers or exchanges of prizes between users are not permitted.
            </p>

            <h4 className="text-lg font-semibold text-green-400 mt-6">Taxes and Fees</h4>
            <p className="text-sm leading-relaxed">
                Users are solely responsible for any fees, duties, or taxes incurred from receiving prizes of any kind, including but not limited to:
                shipping, import costs, and other associated charges.
            </p>

            <h4 className="text-lg font-semibold text-green-400 mt-6">Liability</h4>
            <p className="text-sm leading-relaxed">
                The user agrees to hold harmless <strong>Sokoloco.gg</strong>, its staff, affiliates, and partners against any and all losses, claims, or damages arising from participation in Store-related activities or prize redemptions.
            </p>

            <h4 className="text-lg font-semibold text-green-400 mt-6">Availability and Limitations</h4>
            <p className="text-sm leading-relaxed">
                All sponsored items are limited in quantity and availability. <strong>Sokoloco.gg</strong> reserves the right to limit the number of items per user or restrict availability based on user location.
                The Store terms and prizes may change at any time without prior notice.
            </p>

            <h4 className="text-lg font-semibold text-green-400 mt-6">Multiple Accounts</h4>
            <p className="text-sm leading-relaxed">
                Only one account per person is permitted. Creating multiple accounts (&quot;Multiple Accounts&quot;) using the same personal information, IP address, or contact details is prohibited.
                <strong>Sokoloco.gg</strong> reserves the right to suspend or delete any Multiple Accounts, revoke all associated prizes, and ban the user from future participation.
            </p>

            <h4 className="text-lg font-semibold text-green-400 mt-6">Test Accounts</h4>
            <p className="text-sm leading-relaxed">
                <strong>Sokoloco.gg</strong> may use internal test accounts for development and quality improvement purposes.
                Any prizes or Kick Points obtained through such accounts are ineligible for redemption.
            </p>

            <h4 className="text-lg font-semibold text-green-400 mt-6">Disclaimer</h4>
            <p className="text-sm leading-relaxed italic">
                Sokoloco.gg does not facilitate or accept any monetary transactions on the website.
                All rewards and offers are provided for free as part of marketing promotions from our partners.
                We do not allow any form of monetary exchange between users and our platform, staff, or affiliates for gaming, giveaways, or Store-related purposes.
            </p>

        </div>
    );
}